export const BEFOREUNLOAD_MSG =
  "If you leave before submitting the form you will lose the reservation. Are you sure you want to leave?";

export const beforeunload = ev => {
  ev.preventDefault();
  return (ev.returnValue = BEFOREUNLOAD_MSG);
};
